export default __webpack_public_path__ + "static/media/htmlcss.e089a1ba.png";